import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "@/views/Login"
import Main from '@/views/Main'
import Desktop from "@/views/Desktop";
import Clients from "@/views/Clients";
import Users from "@/views/Users";
import CardClient from "@/views/CardClient";
import CardSubscribe from "@/views/CardSubscribe";
import CardSubscribeHistory from "@/views/CardSubscribeHistory";
import CardPackage from "@/views/CardPackage";
import Sale from "@/views/Sale";
import SaleHistory from "@/views/SaleHistory";
import SaleHistoryNew from "@/views/SaleHistoryNew";
import Schedule from "@/views/Schedule";
import Lesson from "@/views/Lesson";
import CreateLesson from "@/views/CreateLesson";
import Return from "@/views/Return";
import ReturnService from "@/views/ReturnService";
import ReturnServiceDetail from "@/views/ReturnServiceDetail";
import ReturnCancelPayment from "@/views/ReturnCancelPayment";
import ReturnFromBill from "@/views/ReturnFromBill";
import Cashbox from "@/views/Cashbox";
import FreezePackage from "@/views/FreezePackage";
import UnfreezePackage from "@/views/UnfreezePackage";
import ChangeOwner from "@/views/ChangeOwner";
import Reports from "@/views/Reports";
import CardClientNew from "@/views/CardClientNew";
import CardClientNewOt from "@/views/CardClientNewOt";
import ReportsTm2 from "@/views/ReportsTm2";
import ReportsSalesDepartment from "@/views/ReportsSalesDepartment";
import ServicePackages from "@/views/ServicePackages";
import PotentialCustomers from "@/views/PotentialCustomers";
import Transactions from "@/views/Transactions";
import TasksPage from "@/views/TasksPage";
import Applications from "@/views/Applications";
import Schedule2 from "@/views/Schedule2";
import Clients2 from "@/views/Clients2";
import CreateClient from "@/views/CreateClient";
import Extension from "@/views/Extension";
import SalesMonitor from "@/views/SalesMonitor";
import TransactionsRenewal from "@/views/TransactionsRenewal";
import TasksRenewal from "@/views/TasksRenewal";
import MembersRenewal from "@/views/MembersRenewal";
import DealsStage from "@/views/DealsStage";
import SalesNodeal from "@/views/SalesNodeal";
import ReportsAdminDepartment from "@/views/Admin/ReportsAdminDepartment";
import AdminMain from "@/views/Admin/AdminMain";
import AdminLessons from "@/views/Admin/AdminLessons";
import AdminStaff from "@/views/Admin/AdminStaff";
import AdminNormatives from "@/views/Admin/AdminNormatives";
import DealsStageRenewal from "@/views/DealsStageRenewal";
import Organization from "@/views/Admin/Organization";
import CreateNomenclature from "@/views/Admin/CreateNomenclature";
import SaleStock from "@/views/SaleStock";
import SaleBuyer from "@/views/SaleBuyer";
import ManagerTasks from "@/views/ManagerTasks";
import CardClientParent from "@/views/CardClientParent";
import CardClientOt from "@/views/CardClientOt";
import CreateNomenclaturePacket from "@/views/Admin/CreateNomenclaturePacket";
import CreateNomenclatureService from "@/views/Admin/CreateNomenclatureService";
import CreateNomenclatureRental from "@/views/Admin/CreateNomenclatureRental";
import CreateNomenclatureDish from "@/views/Admin/CreateNomenclatureDish";
import CreateNomenclatureStore from "@/views/Admin/CreateNomenclatureStore";
import CreateNomenclatureModifier from "@/views/Admin/CreateNomenclatureModifier";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    meta: { logout: true }
  },
  {
    path: '/main',
    name: 'Main',
    component: Main,
    meta: { requiresAuth: true }
  },
  {
    path: '/desktop',
    name: 'Desktop',
    component: Desktop,
    props: true,
    meta: { requiresAuth: true, meta:'Рабочий стол' }
  },
  {
    path: '/clients',
    name: 'Clients',
    component: Clients,
    meta: { requiresAuth: true, meta:'Клиенты' }
  },
  {
    path: '/users',
    name: 'McvUser',
    component: Users,
    meta: { requiresAuth: true }
  },
  {
    path: '/card-client',
    name: 'CardClient',
    component: CardClient,
    props: true,
    meta: { requiresAuth: true, meta:'Профиль' }
  },
  {
    path: '/card-client-ot',
    name: 'CardClientOt',
    component: CardClientOt,
    props: true,
    meta: { requiresAuth: true, meta:'Профиль' }
  },
  {
    path: '/card-potential-client',
    name: 'CardClientNew',
    component: CardClientNew,
    props: true,
    meta: { requiresAuth: true, meta:'Карточка' }
  },
  {
    path: '/card-potential-client-ot',
    name: 'CardClientNewOt',
    component: CardClientNewOt,
    props: true,
    meta: { requiresAuth: true, meta:'Карточка' }
  },
  {
    path: '/card-subscribe',
    name: 'CardSubscribe',
    props: true,
    component: CardSubscribe,
    meta: { requiresAuth: true }
  },
  {
    path: '/card-subscribe-history',
    name: 'CardSubscribeHistory',
    props: true,
    component: CardSubscribeHistory,
    meta: { requiresAuth: true }
  },
  {
    path: '/card-package',
    name: 'CardPackage',
    props: true,
    component: CardPackage,
    meta: { requiresAuth: true }
  },
  {
    path: '/sale',
    name: 'Sale',
    component: Sale,
    props: true,
    meta: { requiresAuth: true, meta:'Продажа' }
  },
  {
    path: '/sale-history',
    name: 'SaleHistory',
    component: SaleHistory,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/sale-history-new',
    name: 'SaleHistoryNew',
    component: SaleHistoryNew,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: Schedule,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/schedule-2',
    name: 'Schedule2',
    component: Schedule2,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/lesson',
    name: 'Lesson',
    component: Lesson,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-lesson',
    name: 'CreateLesson',
    component: CreateLesson,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/return',
    name: 'Return',
    component: Return,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/return-service',
    name: 'ReturnService',
    component: ReturnService,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/return-service-detail',
    name: 'ReturnServiceDetail',
    component: ReturnServiceDetail,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/return-payment',
    name: 'ReturnCancelPayment',
    component: ReturnCancelPayment,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/return-bill',
    name: 'ReturnFromBill',
    component: ReturnFromBill,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/cashbox',
    name: 'Cashbox',
    component: Cashbox,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/freeze-package',
    name: 'FreezePackage',
    component: FreezePackage,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/unfreeze-package',
    name: 'UnfreezePackage',
    component: UnfreezePackage,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/change-owner',
    name: 'ChangeOwner',
    component: ChangeOwner,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports-2',
    name: 'ReportsTm2',
    component: ReportsTm2,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports-sales-department',
    name: 'ReportsSalesDepartment',
    component: ReportsSalesDepartment,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/service-packages',
    name: 'ServicePackages',
    component: ServicePackages,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/potential-customers',
    name: 'PotentialCustomers',
    component: PotentialCustomers,
    props: true,
    meta: { requiresAuth: true, title: "Потенциальные клиенты"},
  },
  {
    path: '/applications',
    name: 'Applications',
    component: Applications,
    props: true,
    meta: { requiresAuth: true, meta:'Заявки' }
  },
  {
    path: '/create-client',
    name: 'CreateClient',
    component: CreateClient,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: Transactions,
    props: true,
    meta: { requiresAuth: true, meta:'Сделки' }
  },
  {
    path: '/extension',
    name: 'Extension',
    component: Extension,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/tasks',
    name: 'TasksPage',
    component: TasksPage,
    props: true,
    meta: { requiresAuth: true, meta:'Задачи' }
  },
  {
    path: '/sales-monitor',
    name: 'SalesMonitor',
    component: SalesMonitor,
    props: true,
    meta: { requiresAuth: true, meta:'Монитор продаж' }
  },
  {
    path: '/clients-2',
    name: 'Clients2',
    component: Clients2,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/transactions-renewal',
    name: 'TransactionsRenewal',
    component: TransactionsRenewal,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/tasks-renewal',
    name: 'TasksRenewal',
    component: TasksRenewal,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/members-renewal',
    name: 'MembersRenewal',
    component: MembersRenewal,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/deals-stage',
    name: 'DealsStage',
    component: DealsStage,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/sales-nodeal',
    name: 'SalesNodeal',
    component: SalesNodeal,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports-admin-department',
    name: 'ReportsAdminDepartment',
    component: ReportsAdminDepartment,
    props: true,
    meta: { requiresAuth: false, requiresAdminAuth:true }
  },
  {
    path: '/admin-main',
    name: 'AdminMain',
    component: AdminMain,
    props: true,
    meta: { requiresAuth: false, requiresAdminAuth:true }
  },
  {
    path: '/admin-lessons',
    name: 'AdminLessons',
    component: AdminLessons,
    props: true,
    meta: { requiresAuth: false, requiresAdminAuth:true }
  },
  {
    path: '/admin-staff',
    name: 'AdminStaff',
    component: AdminStaff,
    props: true,
    meta: { requiresAuth: false, requiresAdminAuth:true }
  },
  {
    path: '/admin-normatives',
    name: 'AdminNormatives',
    component: AdminNormatives,
    props: true,
    meta: { requiresAuth: false, requiresAdminAuth:true }
  },
  {
    path: '/deals-stage-renewal',
    name: 'DealsStageRenewal',
    component: DealsStageRenewal,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/organization',
    name: 'Organization',
    component: Organization,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-nomenclature',
    name: 'CreateNomenclature',
    component: CreateNomenclature,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-nomenclature-packet',
    name: 'CreateNomenclaturePacket',
    component: CreateNomenclaturePacket,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-nomenclature-service',
    name: 'CreateNomenclatureService',
    component: CreateNomenclatureService,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-nomenclature-rental',
    name: 'CreateNomenclatureRental',
    component: CreateNomenclatureRental,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-nomenclature-dish',
    name: 'CreateNomenclatureDish',
    component: CreateNomenclatureDish,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-nomenclature-store',
    name: 'CreateNomenclatureStore',
    component: CreateNomenclatureStore,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/create-nomenclature-modifier',
    name: 'CreateNomenclatureModifier',
    component: CreateNomenclatureModifier,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/sale-stock',
    name: 'SaleStock',
    component: SaleStock,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/sale-buyer',
    name: 'SaleBuyer',
    component: SaleBuyer,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/manager-tasks',
    name: 'ManagerTasks',
    component: ManagerTasks,
    meta: { requiresAuth: true }
  },
  {
    path: '/card-potential-client-parent',
    name: 'CardClientParent',
    component: CardClientParent,
    props: true,
    meta: { requiresAuth: true, meta:'Карточка Родст' }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
